import React from "react";
import PropTypes from "prop-types";

import { formatDistanceToNow } from "date-fns";
import { formatDate } from "utils/dates";

import Modal from "components/Modal";
import Table from "components/Table";

import { useSharedResourceHistory } from "./hooks";
import { SharedResourceStatus } from "../../..";

const tableColumns = [
  { id: "sharedBy", label: "Shared By" },
  { id: "version", label: "Version" },
  { id: "sharedOn", label: "Shared On" },
  { id: "sharedWith", label: "Shared With" },
  { id: "status", label: "Status" },
];

const SharedResourceHistoryModal = ({ resource, onClose }) => {
  const {
    sharedResourceHistory,
    totalCount,
    initialLoading,
    isReloading,
    updatePageControl,
    pageControl,
  } = useSharedResourceHistory(resource.id);

  return (
    <React.Fragment>
      <Modal isModalOpen onClose={onClose}>
        <Modal.Header titleAlign="center" onClose={onClose}>
          {resource.name} - Sharing History
        </Modal.Header>
        <Modal.Body scrolling>
          <Table data-test="shared-resource-history-table">
            <Table.Content>
              <Table.Header
                columns={tableColumns}
                rowCount={sharedResourceHistory?.length}
              />
              <Table.Body
                isLoading={initialLoading}
                isReloading={isReloading}
                columns={tableColumns}
                emptyDataMessage="There is no sharing history for this resource."
                data={sharedResourceHistory.map((history) => {
                  return {
                    ...history,
                    sharedOn: (
                      <span
                        title={formatDate("simpleDateTime")(history.sharedOn)}
                      >
                        {formatDistanceToNow(history.sharedOn, {
                          addSuffix: true,
                          includeSeconds: true,
                        })}
                      </span>
                    ),
                    status: (
                      <SharedResourceStatus
                        status={history.status}
                        size="small"
                      />
                    ),
                  };
                })}
              />
            </Table.Content>
          </Table>
          <Table.PaginationControl
            isLoading={initialLoading || isReloading}
            totalCount={totalCount || 0}
            page={pageControl.page || 0}
            pageSize={pageControl.pageSize || 0}
            onPageChange={updatePageControl}
            onPageSizeChange={updatePageControl}
          />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

SharedResourceHistoryModal.propTypes = {
  resource: PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

SharedResourceHistoryModal.defaultProps = {};

export default SharedResourceHistoryModal;
